// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ifkrklrmsjszdloohxvx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlma3JrbHJtc2pzemRsb29oeHZ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc2NDc3NTIsImV4cCI6MjA5MzIyMzc1Mn0.s6vfvYJPNbez6rWRYA2Po61OW4CC7CSabvk18-mkITo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Explicit so the OAuth callback handler in /auth/callback knows what
    // shape to expect: `?code=…` from the redirect, exchanged for a session
    // via supabase-js's auto-detect.
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});